const LOCAL_API = "http://localhost:8000";
const LOCAL_LANDING_API = "http://localhost:4000";

const getAppEnv = () => process.env.REACT_APP_ENV || "development";

export const getFrontUrl = () => {
  switch (getAppEnv()) {
    case "production":
      return "https://pms.rawdalsaleheen.edu.kw/#/";
    case "backup":
      return "https://25-26.rawdalsaleheen.edu.kw/#/";
    case "staging":
      return "https://pms.rss-app.com/#/";
    case "development":
    default:
      return "http://localhost:3000/";
  }
};

/** Read API base URL at call time (after setBaseUrl has written localStorage). */
export const getApiEndpointUrl = () => {
  switch (getAppEnv()) {
    case "production":
      return localStorage.getItem("edu") || "";
    case "backup":
        return localStorage.getItem("backup") || "";
    case "staging":
      return localStorage.getItem("com") || "";
    case "development":
    default:
      return localStorage.getItem("com") || LOCAL_API;
  }
};

export const getLpApiEndpointUrl = () => {
  switch (getAppEnv()) {
    case "production":
    case "backup":
    case "staging":
      return localStorage.getItem("landing") || "";
    case "development":
    default:
      return localStorage.getItem("landing-local") || LOCAL_LANDING_API;
  }
};

/** Lazy env object — always reads current localStorage values. */
export const env = {
  get FRONT_URL() {
    return getFrontUrl();
  },
  get API_ENDPOINT_URL() {
    return getApiEndpointUrl();
  },
  get LP_API_ENDPOINT_URL() {
    return getLpApiEndpointUrl();
  },
};

export { LOCAL_API, LOCAL_LANDING_API };
